import { useMutation } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { resendBiometryOnly } from '~/services-v2/contract-formalization-api/contract-formalization-api'

export default function useBiometryResend(projectId: Ref<string>) {
  const mutationFn = async () => {
    return resendBiometryOnly(projectId.value)
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.CONTRACT_BIOMETRY.RESEND_BIOMETRY,
    retry: 3,
    retryDelay: 1000,
  })
}
